import { render } from "./FormFieldPrice.vue?vue&type=template&id=a8ab9f9e"
import script from "./FormFieldPrice.vue?vue&type=script&lang=js"
export * from "./FormFieldPrice.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__